import { render, staticRenderFns } from "./ReceiptLoader.vue?vue&type=template&id=0a3ae2cb&"
import script from "./ReceiptLoader.vue?vue&type=script&lang=js&"
export * from "./ReceiptLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports